export const defaultConfig = {
  client_name: "",
  client_url: "",
  custom_incident: false,
  key_prefix: "",
  routing_key: "",
  pager_duty_title: null,
  incident_key: null
};
